import Scrollbar from "../../../../../Public/Frontend/src/scripts/helpers/scrollbarWidth";

export default class Header {
	static init() {
		// scrollbar with detection
		new Scrollbar();

		// init navigation
		new Header(document.querySelector('.header'), document.querySelector('.search-modal'));
	}

	constructor(element, modalSearch) {
		if(!element) {
			return;
		}
		this.header = element;
		this.navigation = element.querySelector('.navigation');
		this.toggleButton = element.querySelector('.navigation__btn-toggle');
		this.modalSearch = modalSearch;
		this.isNavigationOpen = false;
        const isMobile = window.innerWidth < 1200;

		window.addEventListener('scroll', () => requestAnimationFrame(() => {
			element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');
		}));
		element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');

		this.setTabIndexes();

		window.addEventListener('click', (e) => {
			const target = e.target;
			const menu = this.navigation.querySelector('.navigation__menu:not(.navigation__menu--with-actions)');
			const menuLink = target.classList.contains('navigation__menu-link') ? target : false;
			const menuBackButton = target.classList.contains('navigation__btn-back') ? target : false;
			const menuItem = menuLink.parentElement;
			const menuDropdown = menuLink && menuItem.querySelector('.navigation__menu-dropdown') || false;
			const isMenuItemActive = menuItem && menuItem.classList.contains('navigation__menu-item--active');
			const menuSearchButton = target.closest('.navigation__menu-link--search') ?? false;
			const modalSearchBackdrop = target.classList.contains('search-modal__backdrop') ? target : false;
			const modalSearchCloseButton = target.classList.contains('search-modal__close-button') ? target : false;
			const toggleButton = target.classList.contains('navigation__btn-toggle') ? target : false;
			const header = target.classList.contains('header') ? target : false;

			if (menuItem && menuDropdown) {
                if (isMobile) {
                    menuItem.classList[isMenuItemActive ? 'remove' : 'add']('navigation__menu-item--active');
                    menu.classList[isMenuItemActive ? 'remove' : 'add']('navigation__menu--open');
                }
			}

			if (menuBackButton) {
				this.hideAll();
			}

			if (menuSearchButton) {
				this.modalSearch.classList.add('search-modal--open');
				this.modalSearch.querySelector('[type="search"]').focus();
			}

			if (modalSearchBackdrop || modalSearchCloseButton) {
				this.modalSearch.querySelector('.search-modal__form').reset();
				this.modalSearch.classList.remove('search-modal--open');
			}

			if (toggleButton) {
				this.toggleMenu();
			}

			if (header) {
				this.closeMenu();
			}
		});
	}

	closeMenu() {
		this.toggleButton.classList.remove('navigation__btn-toggle--is-active');
		this.navigation.classList.remove('navigation--is-active');
		document.body.classList.remove('menu-open');
		window.scrollTo(0, parseInt(document.body.style.top || '0') * -1);
		document.body.style.top = 'auto';
		this.isNavigationOpen = false;
	}

	openMenu() {
		this.toggleButton.classList.add('navigation__btn-toggle--is-active');
		this.navigation.classList.add('navigation--is-active');
		document.body.classList.add('menu-open');
		this.isNavigationOpen = true;
	}

	toggleMenu() {
		this.isNavigationOpen ? this.closeMenu() : this.openMenu();
	}

	hideAll() {
		Array.prototype.forEach.call(this.navigation.querySelectorAll('.navigation__menu-item--active'), el => {
			el.classList.remove('navigation__menu-item--active');
		});
		this.navigation.querySelector('.navigation__menu:not(.navigation__menu--with-actions)').classList.remove('navigation__menu--open');
	}

	setTabIndexes() {
		let counter = 1;
		let appsMenuItems = this.navigation.querySelectorAll('.navigation__menu-wrapper + .navigation__menu-wrapper .navigation__menu > .navigation__menu-item');
		Array.prototype.forEach.call(appsMenuItems, (el) => {
			let submenu = el.querySelector('.navigation__menu-dropdown');

			if (submenu) {
				let menuItem = el.querySelector('.navigation__menu-link a')

				if (!menuItem) return;
				menuItem.setAttribute('tabindex', ('' + counter));
				counter++;

				let submenuItems = submenu.querySelectorAll('.navigation__menu-link')
				Array.prototype.forEach.call(submenuItems, (_el) => {
					_el.setAttribute('tabindex', ('' + counter));
					counter++;

					_el.addEventListener("blur", function () {
						_el.parentElement.parentElement.parentElement.classList.remove('is-visible');
					});

					_el.addEventListener("focus", function () {
						_el.parentElement.parentElement.parentElement.classList.add('is-visible');
					});
				});
			} else {
				let menuItem = el.querySelector('a.navigation__menu-link');

				if (!menuItem) return;
				menuItem.setAttribute('tabindex', ('' + counter));
				counter++;
			}
		});
	}
}
